export default __webpack_public_path__ + "static/media/pokemon-background.ebc0aef1.mp4";